/**************************************************
 * Nombre:       Home_Mixlrs
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import '@splidejs/react-splide/css';
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";
import logo from '../../../Recursos/logo_mixlrs.svg'
import Tarjeta_Mixlr from "../../Tarjetas/Tarjeta_Mixlr";
import useRecuperarColleccionListeningProg from "../../../Servicios/BD/useRecuperarColleccionListeningProg";
import {useState} from "react";

const Home_Mixlrs = () => {
    const {sCell} = useResponsive()
    const [wheres, setWhere] = useState([])
    const {data} = useRecuperarColleccionListeningProg({col: 'mixlrs', numero: sCell ? 3 : 6, wheres: wheres, direccion: 'desc'})


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                overflowX: 'hidden',

            }}
        >
            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, mt: 0}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                            <Grid
                                container
                                justifyContent={'center'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                    <Typography
                                        sx={{
                                            color: '#262626',
                                            fontSize: sCell ? 32 : 40,
                                            fontWeight: 700,
                                            textAlign: 'center',
                                            lineHeight: 1.2
                                        }}>
                                        Conectando Ideas y Experiencias
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 8}}
                                      sx={{justifyContent: 'center', mt: 0}}>
                                    <Typography
                                        sx={{
                                            color: '#545454',
                                            fontSize: sCell ? 14 : 16,
                                            fontWeight: 400,
                                            textAlign: 'center'
                                        }}>
                                        Sintoniza nuestros programas en Mixlr y descubre conversaciones inspiradoras,
                                        historias reales y aprendizajes que impulsan tu crecimiento personal y
                                        profesional.
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4}}>
                                    <img src={logo} width={sCell ? 150 : 200} height={'auto'}/>
                                </Grid>


                            </Grid>

                        </Grid>

                        <Grid container size={{xs: 10, sm: 12, md: 10}}
                              sx={{justifyContent: 'flex-start', mt: 8}}>
                            <Grid
                                container
                                justifyContent={'center'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={4}
                            >


                                {data.map((it, index) => (
                                    <Grid container size={{xs: 12, sm: 4, md: 4}} sx={{justifyContent: 'flex-start'}}>
                                        <Tarjeta_Mixlr item={it}/>
                                    </Grid>
                                ))}

                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Mixlrs

const items = [1, 2]